import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CertifyComponent } from './certify.component';
import { TranslateService } from '@ngx-translate/core';
import { registerLibTranslations } from 'core';
import { CERTIFY_TRANSLATIONS } from './i18n/certify.translations';

const routes: Routes = [{ path: '', component: CertifyComponent }];

@NgModule({
  declarations: [CertifyComponent],
  imports: [RouterModule.forChild(routes)],
  exports: [CertifyComponent],
})
export class CertifyModule {
  constructor(translate: TranslateService) {
    registerLibTranslations(translate, CERTIFY_TRANSLATIONS);
  }
}
